<script>
  import './style.scss';
  import template from './template.html';
  import axios from 'axios';
  import { ChevronDownIcon, ChevronUpIcon } from '../icons.js';
  import {EventBus} from "../../event-bus";

  export default {

    props: [],

    created () {
      this.getRecentlyViewed();
    },

    computed: {

      hasOrders () {
        return this.orders.length > 0;
      }
    },

     mounted() {
         EventBus.$on('toggle-recently-viewed-orders', () => {
             this.isActive = false;
         })
     },

      methods: {

      toggle () {
        this.isActive = !this.isActive;
      },

      clearRecentlyViewed () {
        axios.delete('/orders/last-viewed')
          .then((response) => {
            console.log('clearing orders');
            this.orders = [];
          });
      },

      getRecentlyViewed () {

        axios.get('/orders/last-viewed')
          .then((response) => {
            this.orders = response.data.orders;
          });
      },

      orderName (order) {
        if (order.company) {
          return `${order.company} - ${order.name} - [${order.id}]`;
        } else {
          return order.id + ': ' + order.name;
        }
      }
    },

    template,

    data () {

      return {
        orders: [],

        isActive: false
      }
    },

    components: {
      ChevronDownIcon,
      ChevronUpIcon
    }
  };
</script>
